module.exports = __webpack_public_path__ + "media/images/expert__johan-djourou-ca2364af036abd6078a3c0083aa5143d.png";